import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "اختيار العدد المناسب من الألواح الشمسية والبطارية والانفرتر";
const DESCRIPTION =
  "احسب نظام الطاقة الشمسية الخاص بك لمنزلك باستخدام هذه الحاسبة.";
const KEYWORDS = "الطاقة الشمسية, حاسبة الطاقة الشمسية, نظام الطاقة الشمسية";
const OG_URL = "https://do-calculate.com/calculator/ar/solar-calculator/";
function SolarCalculator() {
  const [consumption, setConsumption] = useState(0);
  const [sunHours, setSunHours] = useState(4);
  const [panelWattage, setPanelWattage] = useState(100);
  const [batteryVoltage, setBatteryVoltage] = useState(24);
  const [cloudyDays, setCloudyDays] = useState(2);
  const [result, setResult] = useState(null);
  const handleCalculate = () => {
    const totalConsumption = consumption * 1.3;
    const panelPowerNeeded = totalConsumption / sunHours;
    const numberOfPanels = Math.ceil(panelPowerNeeded / panelWattage);
    const batteryCapacityNeeded =
      (totalConsumption * cloudyDays * 1.3) / batteryVoltage;
    const numberOfBatteries = Math.ceil(batteryCapacityNeeded / 80);
    const inverterSize = (220 * 1.3).toFixed(2);
    setResult({
      panelPowerNeeded: panelPowerNeeded.toFixed(2),
      numberOfPanels,
      batteryCapacityNeeded: batteryCapacityNeeded.toFixed(2),
      numberOfBatteries,
      inverterSize,
    });
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقدم لك حاسبتنا المجانية أداة سهلة الاستخدام لحساب نظام الطاقة
                  الشمسية المثالي لمنزلك. ببساطة، أدخل بيانات استهلاكك الحالي
                  وموقعك الجغرافي، واحصل على تقدير دقيق لعدد الألواح الشمسية
                  والبطاريات والمنظم اللازم لتلبية احتياجاتك. استمتع بالطاقة
                  النظيفة والمجانية، ووفر على فواتير الكهرباء مع نظام طاقة شمسية
                  مصمم خصيصًا لك.
                </p>
                <p>لحساب نظام الطاقة الشمسية الخاص بك، اتبع الخطوات التالية:</p>
                <ul>
                  <li>حساب كمية الطاقة المستهلكة في اليوم.</li>
                  <li>حساب عدد الألواح الشمسية المطلوبة.</li>
                  <li>حساب عدد البطاريات المطلوبة.</li>
                  <li>حساب حجم المنظم الشمسي والمحول.</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="consumption">
                      <label className="form-label ms-2">
                        أدخل إجمالي الطاقة المستهلكة في اليوم (واط/ساعة)
                      </label>
                      <input
                        id="consumption"
                        type="number"
                        value={consumption}
                        onChange={(e) => setConsumption(e.target.value)}
                        placeholder="أدخل إجمالي الطاقة المستهلكة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="sunHours">
                      <label className="form-label ms-2">
                        أدخل عدد ساعات الشمس في اليوم
                      </label>
                      <input
                        id="sunHours"
                        type="number"
                        value={sunHours}
                        onChange={(e) => setSunHours(e.target.value)}
                        placeholder="عدد ساعات الشمس"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="panelWattage">
                      <label className="form-label ms-2">
                        قدرة اللوح الشمسي (وات)
                      </label>
                      <input
                        id="panelWattage"
                        type="number"
                        value={panelWattage}
                        onChange={(e) => setPanelWattage(e.target.value)}
                        placeholder="أدخل قدرة اللوح"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="batteryVoltage">
                      <label className="form-label ms-2">
                        فولتية البطارية (فولت)
                      </label>
                      <input
                        id="batteryVoltage"
                        type="number"
                        value={batteryVoltage}
                        onChange={(e) => setBatteryVoltage(e.target.value)}
                        placeholder="أدخل فولتية البطارية"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="cloudyDays">
                      <label className="form-label ms-2">
                        عدد الأيام الغائمة المتوقعة (في الأسبوع)
                      </label>
                      <input
                        id="cloudyDays"
                        type="number"
                        value={cloudyDays}
                        onChange={(e) => setCloudyDays(e.target.value)}
                        placeholder="أدخل عدد الأيام الغائمة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتائج:</h4>
                      <p>
                        الطاقة المطلوبة من الألواح الشمسية:{" "}
                        {result.panelPowerNeeded} وات
                      </p>
                      <p>
                        عدد الألواح الشمسية المطلوبة: {result.numberOfPanels}
                      </p>
                      <p>
                        سعة البطاريات المطلوبة: {result.batteryCapacityNeeded}{" "}
                        أمبير ساعة
                      </p>
                      <p>عدد البطاريات المطلوبة: {result.numberOfBatteries}</p>
                      <p>حجم المحول المطلوب: {result.inverterSize} وات</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">تفاصيل إضافية</div>
              <div className="info-section-body">
                <p>
                  للحصول على المزيد من التفاصيل حول كيفية حساب نظام الطاقة
                  الشمسية الخاص بك، يمكنك زيارة المواقع المتخصصة أو الاتصال
                  بالخبراء في المجال.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    كيفية حساب الطاقة المستهلكة
                  </h2>
                </u>
                <p>
                  لحساب إجمالي الطاقة المستهلكة في اليوم، يجب حساب استهلاك جميع
                  الأجهزة الكهربائية في المنزل.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    مثال: إذا كنت تستخدم تلفاز بقدرة 100 واط لمدة 4 ساعات،
                    ومصباح بقدرة 10 واط لمدة 5 ساعات، فإن الطاقة المستهلكة تكون:
                  </p>
                  <ul>
                    <li>التلفاز: 100 واط × 4 ساعات = 400 واط/ساعة</li>
                    <li>المصباح: 10 واط × 5 ساعات = 50 واط/ساعة</li>
                    <li>إجمالي الطاقة المستهلكة: 400 + 50 = 450 واط/ساعة</li>
                  </ul>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    كيفية حساب عدد الألواح الشمسية المطلوبة
                  </h2>
                </u>
                <p>
                  لحساب عدد الألواح الشمسية المطلوبة، نقسم الطاقة المطلوبة من
                  الألواح على قدرة اللوح الواحد.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    مثال: إذا كانت الطاقة المطلوبة من الألواح 1500 واط وقدرة
                    اللوح الواحد 250 واط، فإن عدد الألواح المطلوبة هو:
                  </p>
                  <p>1500 واط / 250 واط لكل لوح = 6 ألواح شمسية.</p>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    كيفية حساب سعة البطاريات المطلوبة
                  </h2>
                </u>
                <p>
                  لحساب سعة البطاريات المطلوبة، نضرب إجمالي الطاقة المستهلكة
                  بعدد الأيام الغائمة ثم نقسم على فولتية البطارية.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    مثال: إذا كانت الطاقة المستهلكة 1000 واط/ساعة في اليوم وعدد
                    الأيام الغائمة 3، وفولتية البطارية 24 فولت، فإن السعة
                    المطلوبة تكون:
                  </p>
                  <p>(1000 واط/ساعة × 3 أيام) / 24 فولت = 125 أمبير ساعة.</p>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    كيفية اختيار المحول المناسب
                  </h2>
                </u>
                <p>
                  للاختيار الأمثل للمحول، يجب التأكد من أن المحول يمكنه تحمل
                  إجمالي الطاقة المستهلكة بالإضافة إلى بعض الاحتياطيات.
                </p>
                <div className="p-3 mb-2 bg-info text-black ">
                  <p>
                    مثال: إذا كان لديك إجمالي استهلاك قدره 2000 واط، يجب اختيار
                    محول بقدرة 2200 إلى 2500 واط للحصول على أفضل أداء واحتياطات
                    أمان.
                  </p>
                </div>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    نصائح لتحسين كفاءة نظام الطاقة الشمسية
                  </h2>
                </u>
                <p>لزيادة كفاءة نظام الطاقة الشمسية لديك، تأكد من:</p>
                <ul>
                  <li>استخدام ألواح ذات جودة عالية مع معدل تحويل مرتفع.</li>
                  <li>
                    التحقق من زاوية الميل المناسبة للألواح حسب موقعك الجغرافي.
                  </li>
                  <li>الحفاظ على الألواح نظيفة وخالية من الأتربة والشوائب.</li>
                </ul>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}
export default SolarCalculator;
